import { render, staticRenderFns } from "./LoginPerfilDialogComponent.vue?vue&type=template&id=346cd37a"
import script from "./LoginPerfilDialogComponent.vue?vue&type=script&lang=js"
export * from "./LoginPerfilDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports